import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=512dc34b&scoped=true"
import script from "./AboutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=512dc34b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512dc34b",
  null
  
)

export default component.exports